import _ from 'lodash';
import { networkInterfaces } from 'os';

let last_ts = null;
let counter = 0;
const ip = getIpAddress();
const node_id = _.last( ip.split( '.' ) ); // TODO - Make this more robust..

export function generateId( ...args ) {
  args = _.flattenDeep( args );
  const ts = Date.now();
  if ( last_ts === ts ) {
    counter++;
  } else {
    last_ts = ts;
    counter = 0;
  }
  return args.concat( [ ts, node_id, counter ].join( '.' ) ).join( '@' );
}

export function parseId( id ) {
  const parts = id.split( '@' );
  return parts;
}

function getIpAddresses( filter={ internal : false, family : 'IPv4' } ) {
  const ifs = _.flatMap( networkInterfaces(), ( addrs, iface ) => {
    return _.map( addrs, addr => ( { ...addr, iface } ) );
  } );
  if ( filter ) return _.filter( ifs, filter );
}

export function getIpAddress() {
  const addrs = getIpAddresses();
  return _.sortBy( addrs, 'iface', 'address' )[0].address;
}
